var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _rect10, _rect11, _path3, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _rect17, _path5, _rect18, _rect19, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveUnreleasedTracks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 474,
    viewBox: "0 0 683 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H682V444C682 460.569 668.569 474 652 474H0V4Z",
    fill: "#21232B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 56,
    width: 184,
    height: 418,
    fill: "#020203",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 95,
    width: 156,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 71,
    width: 40,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 191,
    width: 149,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 215,
    width: 153,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 239,
    width: 118,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 119,
    width: 115,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 143,
    width: 131,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 167,
    width: 92,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H682V56H0V4Z",
    fill: "#141519"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 120,
    width: 498,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 376,
    width: 499,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184 440H682V444C682 460.569 668.569 474 652 474H184V440Z",
    fill: "white",
    fillOpacity: 0.02
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 184,
    width: 498,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 248,
    width: 498,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 56,
    width: 498,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 312,
    width: 499,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 56,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M518 315C518 313.343 519.343 312 521 312H682V372H521C519.343 372 518 370.657 518 369V315Z",
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 120,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M626 379C626 377.343 627.343 376 629 376H682V436H629C627.343 436 626 434.657 626 433V379Z",
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 184,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 248,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 28.0013V23H34.9452L38.3867 28.0012H50.666V33H41.7385L38.2969 28.0013H17Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveUnreleasedTracks);
export default __webpack_public_path__ + "static/media/remove-unreleased-tracks.5b224efd47eb90d921bc7988ebf2be0b.svg";
export { ForwardRef as ReactComponent };